var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "professional-list" },
    [
      _c("div", { staticClass: "header" }, [
        _vm._m(0),
        _vm._v(" "),
        !_vm.orderOfferExpired
          ? _c("div", { staticClass: "right" }, [
              _c("span", { staticClass: "text" }, [_vm._v("TEMPO RESTANTE")]),
              _vm._v(" "),
              _c("div", { staticClass: "countdown" }, [
                _vm.time
                  ? _c(
                      "div",
                      [
                        _c("span", [_vm._v(_vm._s(_vm.time))]),
                        _vm._v(" "),
                        _c("ProgressBar", {
                          attrs: { progress: _vm.percentageTimeLeft() }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      !_vm.avaliableProfessionals.length ? _c("Empty") : _vm._e(),
      _vm._v(" "),
      _vm.avaliableProfessionals.length
        ? _c(
            "div",
            { staticClass: "list" },
            _vm._l(_vm.avaliableProfessionals, function(professional) {
              return _c("Card", {
                key: professional.id,
                attrs: {
                  professional: professional,
                  shouldApplyFocus: Boolean(_vm.professionalId),
                  isSelected: professional.id === _vm.professionalId
                }
              })
            })
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.avaliableProfessionals.length && _vm.orderOfferExpired
        ? _c("p", { staticClass: "expired-offer" }, [
            _vm._v(
              "\n    Esses são os profissionais que aceitaram realizar a limpeza.\n  "
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "left" }, [
      _c("p", [_vm._v("Buscando profissionais perto de você")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-578fdf21", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-578fdf21","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PurchaseFlow/Components/Scheduler/Steps/ProfessionalOfferList/Index.vue
// module id = null
// module chunks = 